import { useDependencies } from "@/shared/context/DependenciesContext";
import type { ErrorConfig } from "@/shared/types/error.types";

export const useErrorHandler = () => {
  const { errorHandlerService } = useDependencies();

  return {
    handleError: (error: unknown, config?: ErrorConfig) => {
      errorHandlerService.handleError(error, config);
    },
    extractApiError: errorHandlerService.extractApiError,
  };
};
